"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rentals = void 0;
const schemas_1 = require("@dcl/schemas");
const abis_1 = require("../abis");
exports.rentals = {
    [schemas_1.ChainId.ETHEREUM_GOERLI]: {
        version: '1',
        abi: abis_1.abis.Rentals,
        address: '0x92159c78f0f4523b9c60382bb888f30f10a46b3b',
        name: 'Rentals',
        chainId: schemas_1.ChainId.ETHEREUM_GOERLI
    },
    [schemas_1.ChainId.ETHEREUM_SEPOLIA]: {
        version: '1',
        abi: abis_1.abis.Rentals,
        address: '0xe70db6319e9cee3f604909bdade58d1f5c1cf702',
        name: 'Rentals',
        chainId: schemas_1.ChainId.ETHEREUM_SEPOLIA
    },
    [schemas_1.ChainId.ETHEREUM_MAINNET]: {
        version: '1',
        abi: abis_1.abis.Rentals,
        address: '0x3a1469499d0be105d4f77045ca403a5f6dc2f3f5',
        name: 'Rentals',
        chainId: schemas_1.ChainId.ETHEREUM_MAINNET
    }
};
//# sourceMappingURL=rentals.js.map